import { motion } from 'framer-motion';
import Carousel from 'react-bootstrap/Carousel';
import servicesData from "./Data";
import { Row, Col, Image, Container } from 'react-bootstrap';
import { FaCode, FaBullhorn, FaSearch } from "react-icons/fa";
import { useState, useEffect } from 'react';
import { MdPhoneAndroid } from "react-icons/md";
import { RiAdvertisementFill } from "react-icons/ri";
import { SiAdobephotoshop } from "react-icons/si";
import { PiCodesandboxLogoLight } from "react-icons/pi";
import { MdVideoChat } from "react-icons/md";
import CounterSection from './CounterSection';
const iconComponents = {
    FaCode: <FaCode />,
    FaBullhorn: <FaBullhorn />,
    FaSearch: <FaSearch />,
    MdPhoneAndroid: <MdPhoneAndroid />,
    RiAdvertisementFill: <RiAdvertisementFill />,
    SiAdobephotoshop: <SiAdobephotoshop />,
    PiCodesandboxLogoLight: <PiCodesandboxLogoLight />,
    MdVideoChat: <MdVideoChat />
};
const skills = [
    { name: "Web Development", percentage: 98 },
    { name: "Digital Marketing", percentage: 95 },
    { name: "SEO Services", percentage: 90 },
    { name: "Social Media Managment", percentage: 99 },
    { name: "Video Adverertisement", percentage: 90 },
    { name: "Graphic Desgin", percentage: 94 },
    { name: "Logo Design", percentage: 85 },
    { name: "Video Editing", percentage: 99 },
];
function Home() {
    const [progress, setProgress] = useState([]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setProgress(skills.map(skill => skill.percentage));
        }, 500);

        return () => clearTimeout(timeout);
    }, []);
    return (
        <>
            <Carousel fade>
                <Carousel.Item className='slider-1'>
                    <motion.div
                        className="welcome-text"
                        initial={{ x: "-100%" }}
                        animate={{ x: 30 }}
                        transition={{ duration: 2, ease: "easeOut" }}
                    >

                        <p style={{ fontWeight: '600' }}>YOUR DREAM<br /> START HERE..!</p>
                    </motion.div>
                </Carousel.Item>
                <Carousel.Item className='slider-2'>
                    <motion.div
                        className="welcome-text"
                        initial={{ x: "-100%" }}
                        animate={{ x: 30 }}
                        transition={{ duration: 2, ease: "easeOut" }}
                    >

                        <p style={{ fontWeight: '600' }}>YOUR FUTURE<br />OUR PRIORITY</p>
                    </motion.div>
                </Carousel.Item>
                <Carousel.Item className='slider-3'>
                    <motion.div
                        className="welcome-text"
                        initial={{ x: "-100%" }}
                        animate={{ x: 30 }}
                        transition={{ duration: 2, ease: "easeOut" }}
                    >

                        <p style={{ fontWeight: '600' }}>DIGITAL SOLUTIONS<br />FOR DREAMS</p>
                    </motion.div>
                </Carousel.Item>
            </Carousel >
            <Container fluid>
                <Row className='my-3' id='aboutus'>
                    <Col lg={6} sm={12} xs={12}>
                        <div>
                            <h5 style={{ color: "#28a745" }}>ABOUT US</h5>
                            <h1 style={{ color: "#ff7043", fontWeight: '700' }}>The Best Digital Solution Since</h1>
                            <h3 style={{ color: "#28a745", fontWeight: '700' }}>03 March 2015</h3>
                            <p style={{ textAlign: "justify", fontWeight: '450', fontSize: '1.1rem' }}>
                                Seedlogix Resources India Private Limited is a Private company incorporated on 03 March 2015. It is classified as Non-government company and is registered at Registrar of Companies, Jaipur. Its authorized share capital is Rs. 10,000,000 and its paid up capital is Rs. 4,972,430. It's NIC code is 729 (which is part of its CIN). As per the NIC code, it is inolved in Other computer related activities [for example maintenance of websites of other firms/ creation of multimedia presentations for other firms etc.].</p>
                                <p style={{ textAlign: "justify", fontWeight: '450', fontSize: '1.1rem' }}>Seedlogix Resources India's Annual General Meeting (AGM) was last held on N/A and as per records from Ministry of Corporate Affairs (MCA), its balance sheet was last filed on 31 March 2023.</p>
                                <p style={{ textAlign: "justify", fontWeight: '450', fontSize: '1.1rem' }}> <i style={{ fontWeight: '550' }}>Directors of Seedlogix Resources India are NIKHIL AGRAWAL and MANISH RAJENDRAPRASAD HARODIA.</i></p>
                                <p style={{ textAlign: "justify", fontWeight: '450', fontSize: '1.1rem' }}>Seedlogix Resources India's Corporate Identification Number (CIN) is U72900RJ2015PTC047147 and its registration number is 47147. Users may contact Seedlogix Resources India on its Email address - nikhil.agrawal@dreamwallets.com. Registered address of Seedlogix Resources India is P N 4, BHASKAR ENCLAVE, NEAR O.T.S J.L.N. MARG JAIPUR , JAIPUR, Rajasthan, India - 302017.
                            </p>
                        </div>
                    </Col>
                    <Col>
                        <Image style={{borderRadius:'10px'}} fluid src={require('../Component/Images/time-img.png')} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h5 style={{ color: "#28a745" }}>OUR SERVICES</h5>
                        <h1 style={{ color: "#ff7043", fontWeight: '700' }}>What We’re Offering?
                        </h1>
                    </Col>
                </Row>
                <div className="row" id='services'>
                    {servicesData.map((service) => (
                        <div
                            key={service.id}
                            className="col-lg-3 col-md-6 col-sm-12 col-xs-12"
                        >
                            <div className="service-card mx-2 my-2">
                                <div className="icon">{iconComponents[service.icon]}</div>
                                <h3 className="title">{service.title}</h3>
                                <p className="description">{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <Row className='my-4'>
                    <Col lg={6} sm={12} xs={12}>
                        <Image fluid src={require('../Component/Images/experience-img.png')} />
                    </Col>
                    <Col lg={6} sm={12} xs={12}>
                        <h5 style={{ color: "#28a745" }}>OUR EXPERIENCE</h5>
                        <h1 style={{ color: "#ff7043", fontWeight: '700' }}>We Are Here To IT Solution With 9 Years Of Experience
                        </h1>
                        <div className="progress-container">
                            {skills.map((skill, index) => (
                                <div key={index} className="skill">
                                    <div className="skill-header">
                                        <span>{skill.name}</span>
                                        <span>{progress[index] || 0}%</span>
                                    </div>
                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{
                                                width: `${progress[index] || 0}%`,
                                                transition: "width 1s ease-in-out",
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
                
            </Container>
            <div>
                    <div style={{ height: "60px" }}></div> {/* Spacer */}
                    <CounterSection />
                    <div style={{ height: "60px" }}></div> {/* Spacer */}
                </div>
            <Carousel fade className='my-4'>
            <Carousel.Item className='slider-4'>
            </Carousel.Item>
            <Carousel.Item className='slider-5'>
            </Carousel.Item>
            <Carousel.Item className='slider-6'>
            </Carousel.Item>
            </Carousel >
        </>
    )
}
export default Home;